import React, { PropsWithChildren } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';

import { cn } from '@shared/utils/lib/ui';

type Props = {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (mobileMenuOpen: boolean) => void;
};

const SwyftxMarginAppContent: React.FC<PropsWithChildren<Props>> = ({
  mobileMenuOpen,
  setMobileMenuOpen,
  children,
}) => (
  <FlexLayout
    direction='column'
    className={cn(
      'relative h-full min-w-[100vw] bg-color-background-pageBG transition-[transform] duration-300 sm:transition-none sm:duration-0',
      mobileMenuOpen ? 'translate-x-[0px] sm:translate-x-[-350px]' : 'translate-x-[-350px]',
    )}
    alignItems='start'
    justifyContent='start'
  >
    <div
      onClick={() => setMobileMenuOpen(false)}
      className={cn(
        'absolute z-50 block h-full w-full bg-black transition-opacity duration-300 md:hidden md:transition-none',
        mobileMenuOpen ? 'cursor-pointer opacity-50' : 'pointer-events-none opacity-0',
      )}
    />
    {children}
  </FlexLayout>
);

export { SwyftxMarginAppContent };
